import { render, staticRenderFns } from "./EditarVeiculo.vue?vue&type=template&id=fec86940&"
import script from "./EditarVeiculo.vue?vue&type=script&lang=js&"
export * from "./EditarVeiculo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports